import { render, staticRenderFns } from "./OfficeExportContentComponent.vue?vue&type=template&id=fb453f46&scoped=true&"
import script from "./OfficeExportContentComponent.vue?vue&type=script&lang=js&"
export * from "./OfficeExportContentComponent.vue?vue&type=script&lang=js&"
import style0 from "./OfficeExportContentComponent.vue?vue&type=style&index=0&id=fb453f46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb453f46",
  null
  
)

export default component.exports